import React, { memo, useState } from 'react';
import { Accordion, Card, Col, Row } from "react-bootstrap";

export const AnalyzeSeedAccordian = memo(({ idx, varietyData, settings }) => {

    const { seedVarietyName, seedVarietyCount,  completedCapacity, /* plannedCapacity, remainingCapacity, pendingCapacity */ } = varietyData;
    const [isOpen, setOpen] = useState(false);

    return (
        <Accordion key={`p-accordian${idx}`} className='primary-accord'>
            <Card key={idx} className='summary-card'>
                <Card.Header className='summary-header' title={seedVarietyName}>
                    <Accordion.Toggle as={Card.Header} eventKey={String(idx)} onClick={(e) => { setOpen(!isOpen); }}>
                        <Row className='m-0 align-items-center'>
                            <div className='mr-auto summary-text'>
                                <p className='mb-0 font-weight-bold summary-value-header'>
                                {/* {`${seedVarietyName}`} */}{`Seed Variety ${idx + 1}`}{` (${seedVarietyCount} ${seedVarietyCount > 1 ? 'loads' : 'load'})`}</p>
                            </div>
                            <div className='text-center' style={{ fontSize: '1.5rem' }}>
                                <span className="mt-2 mr-2 storage-icon-container text-muted">{isOpen ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}</span>
                            </div>
                        </Row>
                    </Accordion.Toggle>
                </Card.Header>
                {isOpen ? <Accordion.Collapse eventKey={String(idx)}>
                    {<Card.Body className='card-grid p-0'>
                        <React.Fragment>
                            <Row className='card-grid-row py-2 px-2'>
                                {/* <Col sm={4} className='card-grid-cell py-3'>
                                    <span>{`Planned Seeds (${settings.weightShortName})`}</span>
                                    <p>{plannedCapacity}</p>
                                </Col>
                                <Col sm={4} className='card-grid-cell py-3'>
                                    <span>{`Completed Seeds (${settings.weightShortName})`}</span>
                                    <p>{completedCapacity}</p>
                                </Col>
                                <Col sm={4} className='card-grid-cell py-3'>
                                    <span>{`Pending Seeds (${settings.weightShortName})`}</span>
                                    <p>{pendingCapacity}</p>
                                </Col>
                                <Col sm={4} className='card-grid-cell py-3'>
                                    <span>{`Remaining Seeds (${settings.weightShortName})`}</span>
                                    <p>{remainingCapacity}</p>
                                </Col> */}
                                <Col sm={6} className='card-grid-cell py-3'>
                                    <span>{`Variety Name`}</span>
                                    <p>{`${seedVarietyName}`}</p>
                                </Col>
                                <Col sm={6} className='card-grid-cell py-3'>
                                    <span>{`Net Weight (${settings.weightShortName})`}</span>
                                    <p>{completedCapacity}</p>
                                </Col>
                            </Row>
                        </React.Fragment>
                    </Card.Body>}
                </Accordion.Collapse> : null}
            </Card>
        </Accordion>
    )
})